import { render, staticRenderFns } from "./ExamQuestionLogs.vue?vue&type=template&id=3a995ce6&scoped=true"
import script from "./ExamQuestionLogs.vue?vue&type=script&lang=js"
export * from "./ExamQuestionLogs.vue?vue&type=script&lang=js"
import style0 from "./ExamQuestionLogs.vue?vue&type=style&index=0&id=3a995ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a995ce6",
  null
  
)

export default component.exports